export const SortingDirection = {
  unspecified: 'unspecified' as const,
  asc: 'asc' as const,
  desc: 'desc' as const,
}
export type SortingDirection =
  (typeof SortingDirection)[keyof typeof SortingDirection]
